<template>
    <DForm @submit.prevent="submitForm">
        <DCard
            :title="__('settings.netledger_settings.name')"
            :padding="true"
            class="mb-4"
        >
            <DFormRow
                :label="__('settings.netledger_settings.form.server_name')"
                :is-required="true"
                :hint="__('settings.netledger_settings.form.server_name_hint')"
            >
                <DInput
                    id="netledger_settings_server_name"
                    v-model="form.server_name"
                    :placeholder="__('settings.netledger_settings.form.server_name')"
                    :is-valid="isFormFieldValid('server_name')"
                    :invalid-feedback="errors.server_name"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.netledger_settings.form.access_token')"
                :is-required="true"
                :hint="__('settings.netledger_settings.form.access_token_hint')"
            >
                <DInput
                    id="netledger_settings_access_token"
                    v-model="form.access_token"
                    :placeholder="__('settings.netledger_settings.form.access_token')"
                    :is-valid="isFormFieldValid('access_token')"
                    :invalid-feedback="errors.access_token"
                    type="text"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatus === 'successful'"
                        class="green-text"
                    >
                        {{ __('settings.netledger_settings.messages.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatus === 'unsuccessful'"
                        class="text-danger"
                    >
                        {{ __('settings.netledger_settings.messages.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.netledger_settings.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection"
                    />
                </DCol>
            </DRow>
        </DCard>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
    <DConnectionErrorModal
        :show-modal="connectionException !== null"
        :exception="connectionException"
        @close-modal="closeModal"
    />
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    settings: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatus = ref(null)
const connectionException = ref(null)
const emit = defineEmits(['form-submitted'])

const form = useForm({
    server_name: props.settings?.server_name ?? '',
    access_token: props.settings?.access_token ?? '',
})

const submitForm = () => {
    emit('form-submitted', form)
}
const checkConnection = (client) => {
    connectionException.value = null
    form.client = client
    window.axios.post(route('settings.netledger-settings.check', form))
        .then(function () {
            connectionStatus.value = 'successful'
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        }
        )
}

function closeModal () {
    connectionException.value = null
}
</script>

<style scoped lang="scss">
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 12px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
